export const SLIM_ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  TRANSFER: '/transfer',
} as const

export type SlimRoute = (typeof SLIM_ROUTES)[keyof typeof SLIM_ROUTES]
